import { restHeartClient } from '@/network'

/**
 *
 * @param db
 * @param collection
 * @param filter
 */
export const getDocumentSize = (db: string, collection: string, filter: any) => {
	console.log('filter', filter)
	return restHeartClient.get(`${db}/${collection}/_size`, { params: { filter: JSON.stringify(filter) } })
}
